import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  AccordionSummary,
  Accordion,
  AccordionDetails,
  Button,
  Autocomplete,
  TextField,
} from "@mui/material";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import { UseCustomerRetention } from "./UseCustomerRetention";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import { UseMyPC } from "../../hooks/UseMyPC";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function ResultGrid(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();

  const { ActiveCampaign, GetSMSTemplateList, getCampaignCustomer } =
    UseCustomerRetention();
  const [state, setState] = useState({
    id: undefined,
    SMSID: undefined,
  });
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  const [SMSTemplate, setSMSTemplate] = useState();
  const [customerRes, setCustomerRes] = useState();
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      const element = document.getElementById("results");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  };

  useEffect(() => {
    if (props.expanded === "results" && props.CampaignID) {
      setState({ ...state, id: props.CampaignID });
      setProgress(true);
      GetSMSTemplateList((sms) => {
        setProgress(false);
        setSMSTemplate(sms);
      });
      getCampaignCustomer(myPc, props.CampaignID, (patterns) => {
        setProgress(false);
        setCustomerRes(patterns);
      });
    }
  }, [myPc, props.CampaignID, props.expanded]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "customer",
      headerName: "عنوان",
      width: 250,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.customer}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      headerName: "موبایل",
      width: 140,
      align: "center",
      headerAlign: "center",
    },
  ];

  return (
    <Accordion
      id="results"
      expanded={props.expanded === "results"}
      onChange={handleChange("results")}
      style={{
        paddingBottom: "15px",
      }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel1")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            مشتری ها
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ height: "25rem" }}>
          {customerRes ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={customerRes.pageCondition.pageCount}
              rows={customerRes.customers}
              paginationMode="server"
              page={customerRes.pageCondition.page - 1}
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={
                customerRes?.pageCondition.totalItemCount
                  ? customerRes.pageCondition.totalItemCount
                  : 0
              }
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{ Pagination: CustomPagination }}
              componentsProps={{
                pagination: {
                  nofab: true,
                  scrollTo: myPc.scrollTo,
                  isLtr: true,
                  rowCount: customerRes?.pageCondition.totalItemCount
                    ? customerRes.pageCondition.totalItemCount
                    : 0,
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: { page: myPc.page },
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 2 }}>
          <Autocomplete
            size="small"
            value={state.SMSID ? state.SMSID : ""}
            onChange={(event, newValue) => {
              if (newValue) {
                setState({ ...state, SMSID: newValue });
              } else {
                setState({ ...state, SMSID: undefined });
              }
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            getOptionLabel={(option) => {
              if (option) {
                return SMSTemplate?.find((m) => m.id == option).title;
              }
              return "";
            }}
            sx={{ width: isSmall ? "100%" : "25%" }}
            fullWidth
            options={SMSTemplate ? SMSTemplate.map((m) => m.id) : []}
            renderInput={(params) => (
              <TextField
                sx={{ input: { textAlign: "center" } }}
                variant="outlined"
                {...params}
                label=""
              />
            )}
          />
          <Button
            variant="contained"
            onClick={() => {
              if (!state.SMSID) {
                enqueueSnackbar("لطفا SMS را انتخاب کنید", {
                  variant: "error",
                  autoHideDuration: 2000,
                  preventDuplicate: true,
                });
                return 500;
              }
              setCheckState({
                show: true,
                name: "فعال کردن کمپین",
              });
            }}
          >
            ثبت
          </Button>
        </Box>
        <YesOrNoDialoge
          checkState={checkState}
          setCheckState={setCheckState}
          callback={() => {
            setProgress(true);
            ActiveCampaign(state, () => {
              setProgress(false);
            });
          }}
        />
      </AccordionDetails>
    </Accordion>
  );
}
